import React, { useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';


// 설문지 유형 11

const ContentWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-top: var(--sp-32);
`;

const TopTitle = styled.strong`
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: var(--mo-fz-md);
    color: var(--color-main-5);
    font-weight: var(--fz-weight-700);
    white-space: pre;
`;

const SelectListBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    max-width: 33rem;
    margin: var(--sp-40) auto 0 auto;
    

    & > ul {
      display: flex;
      justify-content: center;
      flex-direction: column;
      gap: var(--sp-80);
      
        & > li {
          display: flex;
          flex-direction: column;
          gap: var(--sp-16);
        }
    }
`;

const QuestionTitle = styled.p`
    display: flex;
    align-items: flex-start;
    gap: var(--sp-04);
    font-size: var(--mo-fz-md);
    font-weight: var(--fz-weight-700);
    color: var(--color-main-gray);
      
      & > b { 
        font-weight: var(--fz-weight-870);
        color: var(--color-main-5);   
      }
`;

const CheckListBox = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: var(--sp-12);    
    & .radio-selectbox {
      width: 100%;
      min-width: var(--sp-56);

      & label {
        white-space: nowrap;
      }
    }
`;

const SurveyCheckList = ({ surveyData, selectedValues, onChange, numType}) => {
  const { items } = surveyData;

  // 번호 결정 함수
  const getItemNumber = (item, itemIdx) => {
    if (item.num) {
      return item.num;
    }
    if (numType === "id") {
      return item.id;
    }
    return itemIdx + 1;
  };

  return (
    <ContentWrap>
      <div>
        <TopTitle>{surveyData.category}</TopTitle>
        <SelectListBox>
          <ul>
            {items.map((item, itemIdx) => (
              <li key={item.id}>
                <QuestionTitle>
                  <b>{getItemNumber(item, itemIdx)}.</b> {item.question} 
                </QuestionTitle>
                <CheckListBox>
                  {item.options.map((option, optIdx) => {
                    const inputId = `${item.id}_${optIdx}`;
                    const checked = selectedValues[item.name]?.value === option.value;

                    return (
                      <div
                        key={inputId}
                        className="radio-selectbox"
                        data-style="chk-box"
                        data-direction="column"
                      >
                        <input
                          type="radio"
                          id={inputId}
                          name={item.name}
                          value={option.value}
                          checked={checked}
                          onClick={(e) => onChange(e, option.markVal)}
                          readOnly
                        />
                        <label htmlFor={inputId}>{option.label}</label>
                      </div>
                    );
                  })}
                </CheckListBox>
              </li>
            ))}
          </ul>
        </SelectListBox>
      </div>
    </ContentWrap>
  );
};



export default SurveyCheckList;